module.exports = __webpack_public_path__ + "img/logo-guru.8acd1249.png";